import {
  CTA,
  DesignTokenSizeEnum,
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { useState } from 'react';
import { useTribalContext } from '@/context/tribal';
import Box from '@/modules/components/Box/Box';
import { isStockCar } from '@/modules/utils/storeUtils';
import { GlobalStoreStateConfiguration } from '@/stores/globalStore';
import { TyreInformationDisclaimerText } from './TyreInformation.styles';
import TyreInformationDetails from './TyreInformationDetails';
import TyreInformationSummary from './TyreInformationSummary';
import { TyreData } from '@/types';
import { LinkText } from '@/styles';

function TyreInformation({
  configuration,
}: {
  configuration: GlobalStoreStateConfiguration;
}) {
  const [showDetails, setShowDetails] = useState(false);
  const [activeItem, setActiveItem] = useState(0);

  const { contentManager } = useTribalContext();

  const key = isStockCar(configuration) ? 'stockData' : 'configData';

  const tyres = configuration[key]?.tyreInformationData?.tyres || [];

  const handleShowDetails = (index: number) => {
    setShowDetails(true);
    setActiveItem(index);
  };

  return (
    <>
      <Box
        position="relative"
        mt={DesignTokenSizeEnum.static200}
        mb={DesignTokenSizeEnum.static250}
      >
        <Box mb={DesignTokenSizeEnum.static250}>
          {showDetails ? (
            <CTA
              tag="button"
              emphasis="tertiary"
              aria-label="Go back button"
              onClick={() => setShowDetails(false)}
            >
              <LinkText appearance={TokenTextAppearance.copy200}>
                {'< ' + contentManager.get('tyre-information-title')}
              </LinkText>
            </CTA>
          ) : (
            <Text appearance={TokenTextAppearance.copy200}>
              {contentManager.get('tyre-information-title')}
            </Text>
          )}
        </Box>
        <Box mb={DesignTokenSizeEnum.static250}>
          {!showDetails ? (
            tyres.map((tyre: TyreData, index: number) => (
              <TyreInformationSummary
                key={tyre.tyreSpecification.tyreTypeIdentifier}
                tyre={tyre}
                onClick={() => handleShowDetails(index)}
              />
            ))
          ) : (
            <TyreInformationDetails tyre={tyres[activeItem]} />
          )}
        </Box>
        <TyreInformationDisclaimerText
          tag={TextTag.p}
          appearance={TokenTextAppearance.copy100}
        >
          <strong>
            {contentManager.get('tyre-information-regulation-text')}
          </strong>
          <br />
          {contentManager.get('tyre-information-disclaimer-text')}
        </TyreInformationDisclaimerText>
      </Box>
    </>
  );
}

export default TyreInformation;
